var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60071 12.6002C3.26895 12.6002 3 12.3316 3 12.0002C3 11.6689 3.26895 11.4002 3.60071 11.4002L19.5693 11.4002C19.5582 11.3878 19.5466 11.3756 19.5347 11.3637L16.0913 7.92436C15.8567 7.69005 15.8567 7.31015 16.0913 7.07583C16.3259 6.84152 16.7062 6.84152 16.9408 7.07583L20.3842 10.5152C21.2053 11.3353 21.2053 12.6649 20.3842 13.485L16.9408 16.9244C16.7062 17.1587 16.3259 17.1587 16.0913 16.9244C15.8567 16.69 15.8567 16.3101 16.0913 16.0758L19.5347 12.6365C19.5465 12.6247 19.558 12.6126 19.569 12.6002L3.60071 12.6002Z",
    fill: "#554596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondensed);
export default __webpack_public_path__ + "static/media/Condensed.fd6e59f2449742f219b501f7c7dfa69b.svg";
export { ForwardRef as ReactComponent };